<template>
  <div>
    <md-card v-if="editing && !preview" style="margin: 0; margin-bottom: 20px">
      <md-card-content>
        <div class="question">
          <md-field>
            <label>Question</label>
            <md-input
              v-model="field.question"
              @keypress.enter="editing = false"
            ></md-input>
          </md-field>

          <template v-if="field.type === 'choice'">
            <md-checkbox
              v-for="option in field.options"
              :key="option.id"
              v-model="option.value"
              disabled
              >{{ option.label }}</md-checkbox
            >
          </template>
        </div>
        <div class="preview" v-if="field.type === 'text'">
          <div>Preview</div>

          <md-field v-if="field.answerLength === 'short'">
            <label>Answer</label>
            <md-input disabled></md-input>
          </md-field>
          <md-field v-else-if="field.answerLength === 'long'">
            <label>Answer</label>
            <md-textarea disabled></md-textarea>
          </md-field>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-switch v-model="answerLength" v-if="field.type === 'text'"
          >Long answer</md-switch
        >
        <md-button @click="$emit('delete-field', field.id)">Delete</md-button>
        <md-button @click="editing = false">Save</md-button>
      </md-card-actions>
    </md-card>
    <div @click="edit" v-else>
      <FormField :field="field" :preview="preview"></FormField>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FormField from "./FormField.vue";

export default {
  name: "EditingFormField",
  props: ["field", "preview"],
  data: () => ({
    editing: true,
  }),
  computed: {
    answerLength: {
      get() {
        return this.field.answerLength === "short" ? false : true;
      },
      set(val) {
        this.field.answerLength =
          this.field.answerLength === "short" ? "long" : "short";
      },
    },
  },
  components: {
    FormField,
  },
  methods: {
    edit() {
      this.editing = this.preview ? false : true;
    },
  },
};
</script>

<style lang="scss" scoped>
.md-checkbox {
  display: flex;
}
</style>